// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"zn-z","title":"An-z","nav":"Bn-z","flexCell":"Cn-z","facetLink":"Dn-z"};